module.exports = __webpack_public_path__ + "static/media/posologie.eab0d515.svg";